export default __webpack_public_path__ + "static/media/valentinesBannerMobile.d3dbb6c2.png";